@if (bannerMessage() && !bannerDismissed()) {
  <div class="header-banner {{ bannerTheme() }} d-flex align-items-center">
    <div class="flex-grow-1">
      {{ bannerMessage() }}
    </div>

    <button andButton color="ghost" size="small" (click)="bannerDismissed.set(true)">
      <anduin-icon name="x" role="button" />
    </button>
  </div>
}

<div class="app-content">
  <ndt-toolbar [config]="toolbarConfig()" />

  <div class="app-main d-flex">
    @if (showSideNav()) {
      <app-sidenav />
    }

    <div class="app-page">
      <ngx-spinner type="ball-clip-rotate" type="ball-clip-rotate" bdColor="rgba(7, 68, 77, 0.8)" color="#ffffff">
        <p style="color: white">Processing...</p>
      </ngx-spinner>
      <router-outlet />
    </div>
  </div>
</div>
